// extracted by mini-css-extract-plugin
module.exports = {"container":"MapTypeControl-hashed__container__SZTDd","mapStyle":"MapTypeControl-hashed__mapStyle__1lo8H","active":"MapTypeControl-hashed__active__14CoX"};